import { Box } from '@mui/material';
import type { FC } from 'react';
import { Spinner } from './Spinner';

export const CenteredSpinner: FC = () => (
  <Box
    alignItems="center"
    justifyContent="center"
    sx={{ display: 'flex', padding: '50px', width: '100%', flexGrow: 1 }}
  >
    <Spinner size="30px" />
  </Box>
);
